import { render } from "./DashboardOfferList.vue?vue&type=template&id=190add70&scoped=true"
import script from "./DashboardOfferList.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferList.vue?vue&type=script&lang=ts"

import "./DashboardOfferList.vue?vue&type=style&index=0&id=190add70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-190add70"

export default script